import { facebookAppId } from '../constants/facebook'

export const LOAD_FACEBOOK = 'LOAD_FACEBOOK'
export function loadFacebook () {
  return dispatch => {
    return new Promise(resolve => {
      dispatch({
        type: LOAD_FACEBOOK,
        state: 'loading'
      })

      window.fbAsyncInit = () => {
        window.FB.init({ appId: facebookAppId })
        dispatch({
          type: LOAD_FACEBOOK,
          state: 'loaded'
        })
        resolve()
      }

      // Load the Facebook SDK asynchronously
      ((d, s, id) => {
        const fjs = d.getElementsByTagName(s)[0]
        if (d.getElementById(id)) {
          return
        }
        const js = d.createElement(s)
        js.id = id
        js.src = 'https://connect.facebook.net/en_US/all.js'
        fjs.parentNode.insertBefore(js, fjs)
      })(document, 'script', 'facebook-jssdk')
    })
  }
}

export const GET_FACEBOOK_LOGIN_STATUS = 'GET_FACEBOOK_LOGIN_STATUS'
export function getFacebookLoginStatus () {
  return dispatch => {
    return new Promise((resolve, reject) => {
      window.FB.getLoginStatus(response => {
        let token = null
        if (response.authResponse && response.authResponse.accessToken) {
          token = response.authResponse.accessToken
        }
        dispatch({
          type: GET_FACEBOOK_LOGIN_STATUS,
          state: response.status,
          token: token
        })
      })
    })
  }
}
